// Mock - Tipos de Documento (doctos)
export const doctosListMock = [
  { id: "CR", label: "CR", checked: true },
  { id: "CN", label: "CN", checked: true },
  { id: "TR", label: "TR", checked: false },
  { id: "CH", label: "CH", checked: true },
  { id: "DA", label: "DA", checked: false },
  { id: "DP", label: "DP", checked: true },

  { id: "FR", label: "FR", checked: true },
  { id: "GP", label: "GP", checked: false },
  { id: "IP", label: "IP", checked: true },
  { id: "NF", label: "NF", checked: true },
  { id: "NP", label: "NP", checked: false },
  { id: "OP", label: "OP", checked: true },
  { id: "PK", label: "PK", checked: false },

  { id: "PC", label: "PC", checked: true },
  { id: "PX", label: "PX", checked: false },
  { id: "RE", label: "RE", checked: true },
  { id: "VL", label: "VL", checked: false },
];

// Mock - Estabelecimentos (estabs)
export const estabsListMock = [
  { id: "SBT", label: "SBT", checked: true },
  { id: "YEL", label: "YEL", checked: false },
  { id: "BAL", label: "BAL", checked: true },
  { id: "ASS", label: "ASS", checked: true },
];
